import { render, staticRenderFns } from "./DetaileList.vue?vue&type=template&id=93531cee&scoped=true&"
import script from "./DetaileList.vue?vue&type=script&lang=js&"
export * from "./DetaileList.vue?vue&type=script&lang=js&"
import style0 from "./DetaileList.vue?vue&type=style&index=0&id=93531cee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93531cee",
  null
  
)

export default component.exports